import {Button, Dropdown, Menu, Typography} from "antd";
import {PERMISSIONS, useUser} from "../../../core/context/UserContext";
import {v4} from "uuid";
import {t} from "i18next";
import ApiService from "../../../core/service/api-service";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useModal} from "../../../core/context/ModalContext";
import RowMenu from "../../../core/components/data-grid/RowMenu";
import {Pages} from "../../../AppRouter";
import Hl7PreviewModal from "../message-viewer/Hl7PreviewModal";

export default function HL7ReportRowMenu({text, row, record})
{
    const {hasPermission} = useUser();
    const {refreshDataGrid} = useDataGrid()
    const {openModal, closeModal} = useModal()

    return (
        <RowMenu text={text} width={'auto'} tail={false}>
            <Menu>
                {
                    hasPermission(PERMISSIONS.HOSPITAL_MANAGER) && (
                        <Menu.Item
                            key={v4()}
                            onClick={() => {
                                openModal(t('HL7 Message'), (
                                    <Hl7PreviewModal
                                        requestMessageId={record?.id}
                                        reportMessageId={row?.id}
                                        defaultTab={'report'}
                                    />
                                ), null, Math.min(1100, window.innerWidth * 0.95))
                            }}
                        >
                            {t('Open Message')}
                        </Menu.Item>
                    )
                }
                {
                    hasPermission(PERMISSIONS.HOSPITAL_MANAGER) && row.reportId && (
                        <Menu.Item
                            key={v4()}
                            onClick={async () => {
                                const res = await ApiService.HL7Service.CreateReportMessage([{reportId: row.reportId}])
                            }}
                        >
                            {t('Recreate Report')}
                        </Menu.Item>
                    )
                }
                {
                    hasPermission(PERMISSIONS.HOSPITAL_MANAGER) && (
                        <Menu.Item
                            key={v4()}
                            onClick={async () => {
                                const res = await ApiService.HL7Service.SendReport([row.id])
                            }}
                        >
                            {t('Send Report')}
                        </Menu.Item>
                    )
                }
            </Menu>
        </RowMenu>
    )
}